"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var common_1 = require("../../../../common");
var Toast_1 = require("../../../../common/Toast");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var getLanguages_1 = require("../../../../lib/getLanguages");
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var Mutation_1 = require("../Graphql/Mutation");
var Queries_1 = require("../Graphql/Queries");
var MonitoringCategory_1 = __importDefault(require("./MonitoringCategory"));
var MonitoringQuestion_1 = __importDefault(require("./MonitoringQuestion"));
function Monitoring() {
    var _a, _b, _c, _d, _e, _f;
    var t = (0, react_i18next_1.useTranslation)().t;
    var organization = (0, org_hook_1.useOrg)().organization, _g = (0, react_1.useState)(false), clickStatus = _g[0], setClickStatus = _g[1], _h = (0, react_1.useState)({
        en: "",
        fr: "",
        rn: "",
    }), languages = _h[0], setLanguages = _h[1], _j = (0, react_1.useState)({
        loading: false,
        error: null,
        success: null,
    }), status = _j[0], setStatus = _j[1], _k = (0, react_1.useState)(null), editMonitorParam = _k[0], setEditMonitorParam = _k[1];
    console.log({ status: status });
    var _l = (0, client_1.useLazyQuery)(Queries_1.GET_MONITORING_CATEGORY, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        onCompleted: function () {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: false })); });
        },
        onError: function () {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: false })); });
        },
    }), callMonitoringCategory = _l[0], getMonitoringCategoryList = _l[1], _m = (0, client_1.useLazyQuery)(Queries_1.GET_MONITORING_QUESTION_WITH_ANSWER, {
        fetchPolicy: "network-only",
        variables: {
            organization_id: organization.id,
            published: true,
        },
    }), callQuesWithAnswer = _m[0], getQuesWithAnswer = _m[1], _o = (0, client_1.useMutation)(Mutation_1.UPSERT_MONITORING_QUESTION_ANSWER, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    }), callUpsertMonitor = _o[0], upsertMonitorResponse = _o[1];
    (0, react_1.useEffect)(function () {
        callMonitoringCategory();
        callQuesWithAnswer();
        (0, getLanguages_1.getLanguages)().then(function (res) {
            setLanguages(res);
        });
        reformatMonitorParam();
    }, []);
    var reformatMonitorParam = function () {
        var reformat = {
            id: null,
            name: JSON.stringify(languages),
            category: null,
            data_type: null,
            sorting_order: null,
            organization_id: organization.id,
            answer: [],
            dependency: null,
            audio: null,
            published: true,
        };
        setEditMonitorParam(reformat);
    };
    var getVal = function (obj) {
        var tmp = [];
        Object.keys(obj).forEach(function (key) {
            var lang = key, name = obj[key] === "" ? null : obj[key];
            tmp.push({
                lang: lang,
                name: name,
            });
        });
        return tmp;
    };
    var saveMonitor = function (formData) {
        var _a, _b, _c, _d, _e;
        window.scroll(0, 0);
        setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        var check_category = typeof formData.category === "object" && formData.category !== null
            ? formData.category.value
            : formData.category, variables = {
            id: formData.id,
            name: formData.name,
            monitoring_category_id: check_category,
            organization_id: organization.id,
            order_by: formData.sorting_order !== null
                ? parseInt(((_a = formData.sorting_order) === null || _a === void 0 ? void 0 : _a.value)
                    ? (_b = formData.sorting_order) === null || _b === void 0 ? void 0 : _b.value
                    : formData.sorting_order)
                : null,
            data_type_id: ((_c = formData.data_type) === null || _c === void 0 ? void 0 : _c.id)
                ? (_d = formData.data_type) === null || _d === void 0 ? void 0 : _d.id
                : formData.data_type,
            answer: formData.answer.length > 0
                ? formData.answer.map(function (ans) { return ({
                    id: ans.id || null,
                    name: ans.answer || ans.name,
                    sorting: ans.sorting || null,
                    published: true,
                }); })
                : [],
            published: true,
            audio: getVal(formData.audio),
            dependent_id: ((_e = formData.dependency) === null || _e === void 0 ? void 0 : _e.id) || null,
        };
        callUpsertMonitor({ variables: { input: [variables] } })
            .then(function (res) {
            callQuesWithAnswer();
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { success: res.data.upsertMonitoringQuestionAnswer, loading: false })); });
            reformatMonitorParam();
        })
            .catch(function (e) {
            setStatus(function (prevState) { return (__assign(__assign({}, prevState), { loading: false })); });
            return e;
        });
    };
    return (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", flex: 1 } },
        (upsertMonitorResponse === null || upsertMonitorResponse === void 0 ? void 0 : upsertMonitorResponse.loading) && react_1.default.createElement(common_1.Spinner, null),
        ((_a = upsertMonitorResponse === null || upsertMonitorResponse === void 0 ? void 0 : upsertMonitorResponse.data) === null || _a === void 0 ? void 0 : _a.upsertMonitoringQuestionAnswer) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t((_b = upsertMonitorResponse === null || upsertMonitorResponse === void 0 ? void 0 : upsertMonitorResponse.data) === null || _b === void 0 ? void 0 : _b.upsertMonitoringQuestionAnswer), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        react_1.default.createElement(MonitoringCategory_1.default, { list: (_d = (_c = getMonitoringCategoryList === null || getMonitoringCategoryList === void 0 ? void 0 : getMonitoringCategoryList.data) === null || _c === void 0 ? void 0 : _c.getMonitoringCategory) !== null && _d !== void 0 ? _d : [] }),
        react_1.default.createElement(HeaderBar_1.default, { title: "monitoring", onSave: function () { return setClickStatus(true); } },
            react_1.default.createElement(MonitoringQuestion_1.default, { categoryList: getMonitoringCategoryList, sortingList: (_f = (_e = getQuesWithAnswer === null || getQuesWithAnswer === void 0 ? void 0 : getQuesWithAnswer.data) === null || _e === void 0 ? void 0 : _e.getQuestionWithAnswer) !== null && _f !== void 0 ? _f : [], language: languages, saveClickStatus: clickStatus, updateSaveClickStatus: function () { return setClickStatus(false); }, saveMonitorData: function (data) { return saveMonitor(data); }, editMonitorParam: editMonitorParam }))));
}
exports.default = Monitoring;
